import { Avatar } from "antd";

interface HeaderUserAvatarProps {
  avatarUrl: string;
  background: string;
  displayName: string;
}

export default function HeaderUserAvatar({
  avatarUrl,
  background,
  displayName,
}: HeaderUserAvatarProps) {
  const normalizedName = displayName.trim() || "用";

  return (
    <Avatar
      alt={`${normalizedName}的头像`}
      className="workspaceUser__avatar"
      shape="square"
      size={32}
      src={avatarUrl || undefined}
      style={avatarUrl ? undefined : { background }}
    >
      {!avatarUrl && normalizedName.slice(0, 1).toUpperCase()}
    </Avatar>
  );
}
